import { Field, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class MetaDto {
  @Field()
  title!: string

  @Field({ nullable: true })
  description?: string

  @Field({ nullable: true })
  keywords?: string

  @Field({ nullable: true })
  ogTitle?: string

  @Field({ nullable: true })
  ogImage?: string

  @Field({ nullable: true })
  ogUrl?: string

  @Field({ nullable: true })
  canonicalUrl?: string
}
